<template>
  <table
    cellspacing="0"
    cellpadding="0"
    min-width="350"
    max-width="350"
    height="94"
    style="background-color: #F8F8F8"
  >
    <tbody>
      <tr>
        <td
          v-if="deliveryInfo.type == 'dir'"
          rowspan="2"
          align="center"
        >
          <a
            style="text-decoration:none;cursor: pointer;display: block; margin-top: 10px;"
            :href="deliveryInfo.url"
            target="_blank"
          >
            <img
              id="fileIconsLink"
              width="40"
              height="40"
              style="width: 40px;height: 40px;margin-left: 8px;border:none"
              :src="require('./source/folder-50.png')"
              border="0"
            >
          </a>
        </td>
        <td
          v-else
          rowspan="2"
        >
          <a
            style="text-decoration: none; cursor: pointer; display: inline-block; margin-top: 10px;"
            :href="deliveryInfo.url"
            target="_blank"
          >
            <img
              id="fileIconsLink"
              width="40"
              height="40"
              style="width: 40px;height: 40px;margin-left: 8px;border:none"
              :src="require('./source/'+ Util.typeIcon(Util.resolvePath(currentData.path).type) +'-50.png')"
              border="0"
            >
          </a>
          <br>
          <span style="display: none; max-height: 0px; font-size: 0px; overflow: hidden; mso-hide: all">&nbsp;文件大小:</span>
          <span
            style="font-size:10px;height:12px;margin-left: 6px;color: #929CA9;display: inline-block;transform: scale(0.75,0.75);font-family: SanFranciscoText-Regular;"
            :title="deliveryInfo.name"
          >{{ currentData.size }}</span><br>
        </td>
        <td
          height="40"
          min-width="180"
          style="min-width: 180px;"
        >
          <span style="display: none; max-height: 0px; font-size: 0px; overflow: hidden; mso-hide: all">分享内容:</span>
          <a
            id="fileLinks"
            style="cursor: pointer;font-size:16px;font-weight:bold; font-family: 'SanFranciscoText-Regular'; color: #050F28; margin-left: 8px; text-decoration: none; display: inline-block; margin-top: 10px;"
            :href="deliveryInfo.url"
            target="_blank"
            :title="deliveryInfo.name"
          >
            {{ Util.resolvePath(currentData.path).name }}
          </a>
          <br>
          <span style="display: none; max-height: 0px; font-size: 0px; overflow: hidden; mso-hide: all">
            &nbsp;鏈接地址:{{ deliveryInfo.url }}
          </span>
        </td>
        <td
          rowspan="2"
          align="left"
          width="68"
        >
          <a
            width="52"
            :href="deliveryInfo.url"
            target="_blank"
            style="text-decoration:none"
          >
            <input
              type="button"
              value="查看"
              width="52"
              height="24"
              style="color:#FFFFFF;margin: 20px 12px 8px;font-size:14px;font-family:'PingFangSC-Regular'; background:#2C7DF1;border-radius: 2px;width:52px;height:24px;border:none;cursor:pointer"
            >
          </a>
        </td>
      </tr>
      <tr>
        <td
          v-if="deliveryInfo.password"
          id="LinkFileSizes"
          height="20"
          align="left"
          style="font-family:'SanFranciscoText-Regular';font-size:12px; color:#67707C; height:20px;line-height:20px;padding-right:1px; margin-left: 4px;display: inline-block;margin-top: 6px;margin-bottom:6px"
        >
          <span>&nbsp;提取码:</span>
          <span style="margin-right:6px">{{ deliveryInfo.password }}</span>
          <span>到期日:</span>
          <span>{{ deliveryInfo.expiration.slice(0,10) }}</span>
        </td>
        <td
          v-else
          id="LinkFileSizes"
          height="20"
          align="left"
          style="font-family:'SanFranciscoText-Regular';font-size:12px; color:#67707C; height:20px;line-height:20px;padding-right:1px; margin-left: 4px;display: inline-block;margin-top: 6px;margin-bottom:6px"
        >
          <span>&nbsp;到期日:</span>
          <span>{{ deliveryInfo.expiration.slice(0,10) }}</span>
        </td>
      </tr>
      <tr>
        <td
          height="30"
          style="font-size:12px;background-color: #f8f8f8;border-top:1px solid #EAEAEA"
          colspan="3"
        >
          <span
            :href="linkFileMainUrl"
            style="font-family:'Microsoft yahei'; margin-left:20px;text-decoration:none; color: #929CA9;"
            target="_blank"
          >
            &nbsp;来自于:&nbsp;{{ currentUser }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import store from 'store'
import * as Util from 'js/util/util'

export default {
  props: {
    deliveryInfo: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      Util,
    }
  },
  computed: {
    currentData() {
      return this.data
    },
    currentUser() {
      return store.getters.userInfo.user_name
    },
    linkFileMainUrl() {
      return window.location.origin
    },
  },
}
</script>
